// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.api.web.handler.YourRentalWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  YourRentalWebApiHandler_enrollRewardsUser,
  YourRentalWebApiHandler_getRenterInsuranceUpsell,
  YourRentalWebApiHandler_getRenterInsuranceUpsell_Path,
  YourRentalWebApiHandler_getYourRentalPageData,
  YourRentalWebApiHandler_getYourRentalPageData_Path,
  YourRentalWebApiHandler_sendRentPaymentRequest,
} from '@zg-rentals/ts-your-rental-api-client';

import type {
  EnrollRewardsUserWebApiResponseDto,
  GetRenterInsuranceUpsellWebApiRequestDto,
  GetRenterInsuranceUpsellWebApiResponseDto,
  GetYourRentalPageDataWebApiResponseDto,
  SendRentPaymentRequestWebApiRequestDto,
} from '@zg-rentals/ts-your-rental-api-client';

export type YourRentalWebApiHandler_enrollRewardsUser_Options = UseMutationOptions<
  EnrollRewardsUserWebApiResponseDto,
  unknown,
  void
>;

/**
 * enroll user into rewards program
 */
export const useYourRentalWebApiHandler_enrollRewardsUser = ({
  httpClient,
  ...options
}: Omit<YourRentalWebApiHandler_enrollRewardsUser_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => YourRentalWebApiHandler_enrollRewardsUser(httpClient),
  });
};

export type YourRentalWebApiHandler_getRenterInsuranceUpsell_Options = UseQueryOptions<
  GetRenterInsuranceUpsellWebApiResponseDto,
  unknown,
  GetRenterInsuranceUpsellWebApiResponseDto,
  readonly [string, GetRenterInsuranceUpsellWebApiRequestDto]
>;

const YourRentalWebApiHandler_getRenterInsuranceUpsell_GetKey = (postData: GetRenterInsuranceUpsellWebApiRequestDto) =>
  [YourRentalWebApiHandler_getRenterInsuranceUpsell_Path, postData] as const;

export const YourRentalWebApiHandler_getRenterInsuranceUpsell_queryOptions = (
  postData: GetRenterInsuranceUpsellWebApiRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: YourRentalWebApiHandler_getRenterInsuranceUpsell_GetKey(postData),
    queryFn: () => YourRentalWebApiHandler_getRenterInsuranceUpsell(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get renter insurance upsell for your rental page with logged-out user
 */
export const useYourRentalWebApiHandler_getRenterInsuranceUpsell = (
  postData: GetRenterInsuranceUpsellWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<YourRentalWebApiHandler_getRenterInsuranceUpsell_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...YourRentalWebApiHandler_getRenterInsuranceUpsell_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useYourRentalWebApiHandler_getRenterInsuranceUpsell.getKey = YourRentalWebApiHandler_getRenterInsuranceUpsell_GetKey;

export type YourRentalWebApiHandler_getYourRentalPageData_Options = UseQueryOptions<
  GetYourRentalPageDataWebApiResponseDto,
  unknown,
  GetYourRentalPageDataWebApiResponseDto,
  readonly [string]
>;

const YourRentalWebApiHandler_getYourRentalPageData_GetKey = () =>
  [YourRentalWebApiHandler_getYourRentalPageData_Path] as const;

export const YourRentalWebApiHandler_getYourRentalPageData_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: YourRentalWebApiHandler_getYourRentalPageData_GetKey(),
    queryFn: () => YourRentalWebApiHandler_getYourRentalPageData(httpClient),
  }) as const satisfies QueryOptions;

/**
 * get your rental page data for logged-in user
 */
export const useYourRentalWebApiHandler_getYourRentalPageData = ({
  httpClient,
  ...options
}: Omit<YourRentalWebApiHandler_getYourRentalPageData_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...YourRentalWebApiHandler_getYourRentalPageData_queryOptions({ httpClient }),
    ...options,
  });
};
useYourRentalWebApiHandler_getYourRentalPageData.getKey = YourRentalWebApiHandler_getYourRentalPageData_GetKey;

export interface YourRentalWebApiHandler_sendRentPaymentRequest_Args {
  postData: SendRentPaymentRequestWebApiRequestDto;
}

export type YourRentalWebApiHandler_sendRentPaymentRequest_Options = UseMutationOptions<
  void,
  unknown,
  YourRentalWebApiHandler_sendRentPaymentRequest_Args
>;

/**
 * send email to invite landlord to rent-payment
 */
export const useYourRentalWebApiHandler_sendRentPaymentRequest = ({
  httpClient,
  ...options
}: Omit<YourRentalWebApiHandler_sendRentPaymentRequest_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: YourRentalWebApiHandler_sendRentPaymentRequest_Args) =>
      YourRentalWebApiHandler_sendRentPaymentRequest(args.postData, httpClient),
  });
};
